module.exports = __webpack_public_path__ + "static/media/slife.cccc8295.jpg";